export type Tracker = {
    id: number,
    name: string,
    hardware_id: string,
    battery: number,
    version: number,
    last: number,
    updatable: boolean,
    server_url: string,
    server_port: number,
    fleetstate: string,
    removed: boolean,
}

export type SortStatus = 'ASC' | 'DESC' | null;

export type SortKey = 'sort_name' | 'sort_hardwareId' | 'sort_battery' | 'sort_version' | 'sort_last' | 'sort_server';

export type FilterKeyBoolean = 'filter_open' | 'filter_viewNoUpdatable' | 'filter_viewUpdatable';
export type FilterKeyString = 'filter_name' | 'filter_hardwareId' | 'filter_battery' | 'filter_version' | 'filter_date' | 'filter_server' | 'filter_transversal_search' | 'filter_fleetstate';
export type FilterKeyNumber = 'filter_port';

export enum ActionStatus {
    TO_ACT = 'TO_ACT',
    ACTING = 'ACTING',
    ACTED = 'ACTED',
    ERROR = 'ERROR',
};

export type BullkActionStatus = {
    [key: number]: ActionStatus,
}
